// assets/fix-atc-label.js
document.addEventListener('DOMContentLoaded', function () {
  // Cache each Add to Cart button's real label on first load
  document.querySelectorAll('.add-to-cart').forEach(function (btn) {
    var label = btn.querySelector('.element-text');
    if (label && label.textContent.trim() !== '') {
      btn.dataset.originalLabel = label.textContent.trim();
    }
  });

  // After any variant option change, give the theme's own update a moment,
  // then restore the label only if it was wiped blank (and the button isn't
  // legitimately disabled/sold out).
  document.addEventListener('change', function (e) {
    if (!e.target.closest('variant-picker, block-variant-picker, fieldset, .product-form')) return;

    setTimeout(function () {
      document.querySelectorAll('.add-to-cart').forEach(function (btn) {
        var label = btn.querySelector('.element-text');
        if (!label) return;
        var isDisabled = btn.disabled || btn.hasAttribute('disabled');
        if (!isDisabled && label.textContent.trim() === '' && btn.dataset.originalLabel) {
          label.textContent = btn.dataset.originalLabel;
        }
      });
    }, 500);
  }, true);
});
